import React from 'react'
import Cropper from 'react-cropper'
import { Modal } from 'antd'

class ImageCropper extends React.Component {
  onCropComplete = () => {
    const imageUrl = this.refs.cropper.getCroppedCanvas().toDataURL()
    this.props.handleOk(imageUrl)
  }

  render() {
    const { isVisible, handleCancel, image, cropRatio } = this.props
    const ratio = 100 / cropRatio / 100

    return (
      <Modal
        title="&nbsp"
        visible={isVisible}
        maskClosable={false}
        onOk={this.onCropComplete}
        onCancel={handleCancel}
      >
        <Cropper
          ref="cropper"
          style={{ height: 400, width: '100%' }}
          src={image ? image : ''}
          aspectRatio={cropRatio ? ratio : undefined}
          guides={true}
        />
      </Modal>
    )
  }
}

export default ImageCropper
